<div style="width: 100%; height: 100%; background-color: var(--tdo-background); border-radius: var(--border-radius); margin-bottom: 6px;" data-cy="case-create-wizard">
  <div style="width: 100%; height: 100%; display: flex; flex-direction: column; overflow-y: hidden;" data-cy="case-create-wizard-container">
    <div style="flex-basis: 40px; background-color: var(--tdo-primary); font-weight: 500; padding: 10px; color: white; border-top-left-radius: var(--border-radius); border-top-right-radius: var(--border-radius); font-size: 20px; display: flex;" data-cy="case-create-wizard-header">
      <div data-cy="case-create-wizard-title">Visit (Case Wizard)</div>
      <div style="position: relative; top: -4px; margin-left: 10px; height: 30px; overflow: hidden;" data-cy="case-create-wizard-teeth-button-container">
        <button matTooltip="Select teeth (Optional)" mat-icon-button color="primary" (click)="openDialogEditTeeth()" data-cy="case-create-wizard-select-teeth-btn">
          <img style="width:23px" src="assets/Images/Calendar/iconToothNew.svg" data-cy="case-create-wizard-teeth-icon">
        </button>
      </div>
      @if (selectedTeeth.length > 0) {
        <div style="font-size: 16px; display: flex; margin-top: 6px;" data-cy="case-create-wizard-selected-teeth-container">
          Selected teeth:
          @for (t of selectedTeeth; track t; let i = $index) {
            <div style="margin-left: 5px; font-weight: 400; font-size: 16px;" data-cy="case-create-wizard-selected-teeth">
              @if (i < selectedTeeth.length - 1) {
                {{t.cfgToothDescriptions[0].Notation}},
              }
              @if (i == selectedTeeth.length - 1) {
                {{t.cfgToothDescriptions[0].Notation}}
              }
            </div>
          }
        </div>
      }
    </div>
    <div class="case-wizard-content" style="flex: 1; padding-top: 4px; overflow-y: hidden;" data-cy="case-create-wizard-content">
      <!--
      <div class="center">
        <mat-progress-spinner diameter=50  *ngIf="isBusy"
          mode="indeterminate"
          color="accent">
        </mat-progress-spinner>
      </div>

      -->
      <mat-horizontal-stepper (selectionChange)="onStepperSelectionChange($event)" labelPosition="bottom" #stepper data-cy="case-create-wizard-stepper">
        <mat-step label="Select a reason" data-cy="case-create-wizard-step-reason"></mat-step>
        @if (selectedProcedure) {
          <mat-step label="Select forms to fill out" data-cy="case-create-wizard-step-forms"></mat-step>
        }
        <mat-step label="Save case" data-cy="case-create-wizard-step-save"></mat-step>
      </mat-horizontal-stepper>
      @if (stepIndex === 0) {
        <div class="flex-row1" style="margin-left: auto; margin-right: auto; max-height: calc(100% - 40px); flex: 1; align-content: flex-start; justify-content: flex-start;" data-cy="case-create-wizard-procedures-container">
          @for (p of aProcedures; track p) {
            <button class="tdo-button tdo-save tileButton" [ngClass]="{'selected': selectedProcedure === p}" (click)="clickProcedureSelected(p)" data-cy="case-create-wizard-procedure-btn-{{p.ProcedureName}}">
              {{p.ProcedureName}}
            </button>
          }
        </div>
      }
      @if (stepIndex === 1) {
        <div style="overflow-y: hidden; max-height: calc(100% - 40px); flex: 1; display: flex; flex-direction: column;" data-cy="case-create-wizard-forms-step">
          <div style="margin-left: 10px; font-size:x-large; color: var(--tdo-primary); font-weight: 500;" data-cy="case-create-wizard-selected-procedure">
            {{selectedProcedure?.ProcedureName}}
          </div>
          <div class="flex-row1" style="margin-left: auto; margin-right: auto; margin-top: 6px; padding-top: 6px; flex: 1; align-content: flex-start; justify-content: flex-start; overflow-y: auto; overflow-x: visible;" data-cy="case-create-wizard-forms-container">
            @if (selectedProcedure?.cfgCaseProcedureForms.length === 0) {
              <div style="width: 100%; height: 100%;" data-cy="case-create-wizard-no-forms-container">
                <div style="margin-left: auto; margin-right: auto; text-align: center;" data-cy="case-create-wizard-no-forms-message">
                  The selected procedure, <span style="color: var(--tdo-primary);" data-cy="case-create-wizard-no-forms-procedure">{{selectedProcedure.ProcedureName}}</span> has no associated forms.
                  <br />
                  You may add default procedure forms in Settings > Procedure.
                </div>
              </div>
            }
            @if (selectedProcedure?.cfgCaseProcedureForms.length > 0) {
              @for (f of selectedProcedure?.cfgCaseProcedureForms; track f) {
                <button class="tdo-button tdo-save tileButton" style="overflow: visible;"
                  [matBadge]="f.SelectedIndex" matBadgePosition="above after" matBadgeColor="accent" [matBadgeHidden]="!f.isSelected"
                  (click)="clickForm(f)" data-cy="case-create-wizard-form-btn-{{f.cfgDForm.DFormName}}">
                  {{f.cfgDForm.DFormName}}
                </button>
              }
            }
          </div>
        </div>
      }
      @if (stepIndex === 2) {
        <div style="display: flex; margin-left: auto; margin-right: auto; margin-bottom: 8px; max-height: calc(100% - 40px); flex: 1; align-content: flex-start; justify-content: flex-start; overflow: hidden;" data-cy="case-create-wizard-save-step">
          <div style="flex: 1; border-radius: var(--border-radius); background-color: white; margin-right: 4px; display: flex; flex-direction: column; overflow: hidden;" data-cy="case-create-wizard-summary-container">
            <div style="color: white; padding: 6px; font-size: 20px; background-color: var(--tdo-primary); border-top-left-radius: var(--border-radius); border-top-right-radius: var(--border-radius);" data-cy="case-create-wizard-summary-header">
              Summary
            </div>
            <div style="flex: 1; padding: 4px; overflow: hidden;" data-cy="case-create-wizard-summary-content">
              <span style="color: var(--tdo-primary); font-weight: 500; font-size: 18px;" data-cy="case-create-wizard-summary-procedure">{{selectedProcedure?.ProcedureName}}</span>
              @if (selectedTeeth.length > 0) {
                <div style="display: flex;" data-cy="case-create-wizard-summary-teeth-container">
                  <span style="font-weight: 500" data-cy="case-create-wizard-summary-teeth-label">Selected teeth:</span>
                  @for (t of selectedTeeth; track t; let i = $index) {
                    <div style="margin-left: 5px; font-weight: 400; font-size: 16px;" data-cy="case-create-wizard-summary-teeth">
                      @if (i < selectedTeeth.length - 1) {
                        {{t.cfgToothDescriptions[0].Notation}},
                      }
                      @if (i == selectedTeeth.length - 1) {
                        {{t.cfgToothDescriptions[0].Notation}}
                      }
                    </div>
                  }
                </div>
              }
              @if (getSelectedForms().length > 0) {
                <div style="height: 100%; max-height: 100%; overflow-y: auto;" data-cy="case-create-wizard-summary-forms-container">
                  <span style="font-weight: 500; font-size: 16px;" data-cy="case-create-wizard-summary-forms-label">Forms:</span>
                  @for (form of getSelectedForms(); track form) {
                    <div style="margin-left: 6px; font-size: 14px;" data-cy="case-create-wizard-summary-form-{{form.cfgDForm.DFormName}}">{{form.cfgDForm.DFormName}}</div>
                  }
                </div>
              }
            </div>
          </div>
          <div style="flex: 1; margin-left: 4px;" data-cy="case-create-wizard-case-name-container">
            <div style="margin-left: 20px;" data-cy="case-create-wizard-case-name-label">Please enter a name for the case that will be created for current patient</div>
            <br />
            <input placeholder="Case Name / Description"
              type="text"
              [value]="caseName"
              (input)="caseName = $event.target.value"
              style="margin-left:20px; outline: unset; border-radius: var(--border-radius); border: 2px solid var(--tdo-primary); padding-left: 6px; padding-right: 6px; padding-top: 2px;"
              data-cy="case-create-wizard-case-name-input"
              />
            </div>
          </div>
        }
        <div style="margin-left: auto; margin-right: auto; display: flex; flex-basis: 60px; min-height: 60px; margin-bottom: 5px; margin-top: 4px;" data-cy="case-create-wizard-actions">
          @if (stepIndex > 0) {
            <button style="margin-right: 10px;" class="tdo-button tdo-save" mat-raised-button matTooltip="Previous step" (click)="stepper.previous()" data-cy="case-create-wizard-back-btn">Back</button>
          }
          @if (stepIndex === 2) {
            <button style="margin-right: 10px;" class="tdo-button tdo-save" mat-raised-button (click)="onReset()" data-cy="case-create-wizard-reset-btn">Reset</button>
          }
          @if (stepIndex === 0 || (stepIndex === 1 && selectedProcedure)) {
            <button class="tdo-button tdo-save" mat-raised-button matTooltip="Next step" (click)="stepper.next()" data-cy="case-create-wizard-next-btn">Next</button>
          }
          @if (stepIndex === 2) {
            <button class="tdo-button tdo-save" mat-raised-button matTooltip="Save" (click)="saveCase()" data-cy="case-create-wizard-save-btn">Save</button>
          }
        </div>
      </div>
    </div>
  </div>
